import React, {Component} from 'react';
import _ from 'lodash';
import moment from 'moment';
import AppBar from 'material-ui/AppBar';
import {
  Step,
  Stepper,
  StepLabel,
} from 'material-ui/Stepper';
import Avatar from 'material-ui/Avatar';
import {pinkA200, transparent} from 'material-ui/styles/colors';
import ExpandTransition from 'material-ui/internal/ExpandTransition';
// App
import API from './api';
import StepService from './StepService';
import StepDate from './StepDate';
import StepIdentity from './StepIdentity';
import StepValidation from './StepValidation';

moment.locale('fr');

export default class OnlineBooking extends Component {

  state = {
    parameters: {
      booking: true,
      allowNewCustomer: false,
      allowEmployee: true,
      validationCode: true,
      mailValidationCode: false,
      bookingValidation: true,
      coiffure: false,
      showPrices: false,
      employees: {},
    },
    loading: false,
    finished: false,
    stepIndex: 0,
    services: {},
    formData: {
      checkedServices: {},
      date: null,
      time: null,
      availableDays: {},
      availableTimes: [],
      isExistingUser: false,
      phone: '',
      email: '',
      name: '',
      existingUser: null,
      description: '',
      employeeId: '0',
      availableEmployees: [],
    },
    createdAgendaBooking: null
  };

  componentDidMount() {
    // Fetch parameters
    API.getParameters()
      .then(response => {
        if (response.data.success) {
          this.setState({
            parameters: {
              booking: (response.data.data.booking === '1'),
              allowNewCustomer: (response.data.data.bookingAllowNewCustomer === '1'),
              allowEmployee: (response.data.data.bookingAllowEmployee === '1'),
              validationCode: (response.data.data.bookingValidationCode === '1'),
              mailValidationCode: (response.data.data.bookingMailValidationCode === '1'),
              bookingValidation: (response.data.data.bookingValidation === '1'),
              coiffure: (response.data.data.coiffure === '1'),
              showPrices: (response.data.data.bookingShowPrices === '1'),
              employees: _.keyBy(response.data.data.employees, 'id'),
            }
          })
        }
      })
      .catch(error => {
        console.log('error parameters', error);
      });

    // Fetch services and categories from server API
    API.getServices()
      .then(response => {
        let newServices = {};
        const entities = {
          "&amp;": "&"
        };

        response.data.data.forEach((service, index) => {
          // Create new service category
          newServices[service.display_order] = {
            id: service.display_order,
            realId: service.id,
            name: service.nom.replace(/&#?\w+;/g, match => entities[match]),
            icon: (
              <Avatar color={pinkA200} backgroundColor={transparent} style={{left: 8}}>
                {service.nom.substring(0, 1)}
              </Avatar>
            ),
            services: {}
          };
          // And all sub-services
          service.services.forEach(subService => {
            // Transform service duration & temps de pause from "h:mm" to minutes
            const durationSplit = subService.duree.split(':');
            const duration = parseInt(60 * durationSplit[0], 10 /* radix base 10 */) + parseInt(durationSplit[1], 10 /* radix */);
            const tempsDePauseSplit = subService.temps_de_pause.split(':');
            const tempsDePause = parseInt(60 * tempsDePauseSplit[0], 10 /* radix base 10 */) + parseInt(tempsDePauseSplit[1], 10 /* radix */);

            newServices[service.display_order].services[subService.display_order] = {
              id: subService.display_order,
              realId: subService.id,
              parentId: service.id,
              name: subService.nom.replace(/&#?\w+;/g, match => entities[match]),
              price: parseFloat(subService.prix).toFixed(2),
              time: duration + tempsDePause
            };
          });
        });


        this.setState({
          services: newServices
        });
      })
      .catch(function (error) {
        console.log('Error fetching services: ', error);
      });
  };

  componentDidUpdate(prevProps, prevState) {
    // Fetch employees availability when checked services change
    if (JSON.stringify(prevState.formData.checkedServices) !== JSON.stringify(this.state.formData.checkedServices)) {
      this.fetchAvailableEmployees();
    }
  }

  getTotalServicesTime = () => {
    let time = 0;

    Object.keys(this.state.formData.checkedServices).forEach(serviceKey => {
      Object.keys(this.state.formData.checkedServices[serviceKey]).forEach(subServiceKey => {

        // If service is checked
        if (this.state.formData.checkedServices[serviceKey][subServiceKey]) {
          // If service exist (already loaded)
          if (this.state.services[serviceKey] && this.state.services[serviceKey].services[subServiceKey]) {
            time += this.state.services[serviceKey].services[subServiceKey].time;
          }
        }
      });
    });

    return time;
  };

  fetchAvailableEmployees() {
    const checkedServices = this.getCheckedServicesId();

    if (checkedServices.length === 0) {
      this.onSetFormData({
        availableEmployees: [],
      });
    }
    else {
      API.getEmployees(JSON.stringify(this.getCheckedServicesId()))
        .then(response => {
          this.onSetFormData({
            availableEmployees: response.data.data.map(id => parseInt(id, 10)),
          });
        })
        .catch(error => {
          console.log('ERROR when fetching employees availablity. Please try again', error);
        });
    }
  }

  getCheckedServicesId = () => {
    const services = this.state.formData.checkedServices;
    let checkedServices = [];

    Object.keys(services).forEach(categoryId => {
      Object.keys(services[categoryId]).forEach(serviceId => {
        if (services[categoryId][serviceId]) {
          checkedServices.push(this.state.services[categoryId].services[serviceId].realId);
        }
      })
    });

    return checkedServices;
  };

  onSaveBooking = () => {
    const {date, time} = this.state.formData;

    let startDate = date;

    startDate.setHours(time.value.substring(0, 2));
    startDate.setMinutes(time.value.substring(2, 4));

    let endDate = moment(startDate);
    startDate = moment(startDate);

    endDate.add(this.getTotalServicesTime(), 'minutes');

    API.saveBooking({
      'id_personnel': JSON.stringify(time.freeEmployees),
      'id_client': this.state.formData.existingUser ? this.state.formData.existingUser.id : null,
      'couleur': 'red',
      'start': startDate.format("YYYY-MM-DD HH:mm:ss"),
      'end': endDate.format("YYYY-MM-DD HH:mm:ss"),
      'id_service': JSON.stringify(this.getCheckedServicesId()),
      'ressource': 1,
      'status': 0,
      'auth': 1,
      'timestamp': Math.floor(Date.now() / 1000),
      'description': this.state.formData.description,
      'gsm': this.state.formData.phone,
      'adresse_mail': this.state.formData.email,
      'parametre': this.state.parameters.mailValidationCode ? 'email' : 'sms',
      'nom': this.state.formData.name
    })
      .then(response => {
        this.setState({
          createdAgendaBooking: response.data.data,
          stepIndex: this.state.stepIndex + 1
        });
      })
      .catch(error => {
        console.log('Error: ' + error);
      });
  };

  dummyAsync = (cb) => {
    this.setState({loading: true}, () => {
      this.asyncTimer = setTimeout(cb, 500);
    });
  };

  handleNext = () => {
    const {stepIndex} = this.state;
    if (!this.state.loading) {
      this.dummyAsync(() => this.setState({
        loading: false,
        stepIndex: stepIndex + 1,
        finished: stepIndex >= 3,
      }));
    }
  };

  handlePrev = () => {
    const {stepIndex} = this.state;
    if (!this.state.loading) {
      this.dummyAsync(() => this.setState({
        loading: false,
        stepIndex: stepIndex - 1,
      }));
    }
  };

  onSetFormData = (data) => {
    let oldformData = this.state.formData;

    // Reset complex values if needed
    if (data.availableTimes)
      oldformData.availableTimes = [];
    if (data.availableEmployees)
      oldformData.availableEmployees = [];

    this.setState(previousState => {
      return {
        formData: _.merge({}, previousState.formData, data)
      };
    });
  };

  handleUpdateAvailableDays = availableDays => {
      this.setState(previousState => {
          const newAvailableDays = {...previousState.formData.availableDays, ...availableDays};

          return {
              formData: _.merge({}, previousState.formData, { availableDays: newAvailableDays })
          };
      });
  };


  getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return (
          <StepService
            services={this.state.services}
            handleNext={this.handleNext}
            formData={this.state.formData}
            onSetFormData={this.onSetFormData}
            coiffure={this.state.parameters.coiffure}
            showPrices={this.state.parameters.showPrices}
          />
        );
      case 1:
        return (
          <StepDate
            handleNext={this.handleNext}
            handlePrev={this.handlePrev}
            formData={this.state.formData}
            onSetFormData={this.onSetFormData}
            onUpdateAvailableDays={this.handleUpdateAvailableDays}
            getTotalServicesTime={this.getTotalServicesTime}
            getCheckedServicesId={this.getCheckedServicesId}
            allowEmployee={this.state.parameters.allowEmployee}
            employees={this.state.parameters.employees}
            availableEmployees={this.state.formData.availableEmployees}
          />
        );
      case 2:
        return (
          <StepIdentity
            allowNewCustomer={this.state.parameters.allowNewCustomer}
            validationCode={this.state.parameters.validationCode}
            mailValidationCode={this.state.parameters.mailValidationCode}
            services={this.state.services}
            handleNext={this.onSaveBooking}
            handlePrev={this.handlePrev}
            formData={this.state.formData}
            onSetFormData={this.onSetFormData}
            allowEmployee={this.state.parameters.allowEmployee}
            employees={this.state.parameters.employees}
          />
        );
      case 3:
        return (
          <StepValidation
            createdAgendaBooking={this.state.createdAgendaBooking}
            handlePrev={this.handlePrev}
            formData={this.state.formData}
            onSetFormData={this.onSetFormData}
            validationCode={this.state.parameters.validationCode}
            mailValidationCode={this.state.parameters.mailValidationCode}
            bookingValidation={this.state.parameters.bookingValidation}
          />
        );
      default:
        return (
          <StepService
            services={this.state.services}
            handleNext={this.handleNext}
            formData={this.state.formData}
            onSetFormData={this.onSetFormData}
          />
        );
    }
  }

  render() {
    const {finished, stepIndex, loading} = this.state;
    const booking = this.state.parameters.booking;

    return (
      <div className="app">
        <AppBar
          title={<span>Rendez-vous en ligne</span>}
          iconElementLeft={<div>&nbsp;</div>}
          className="app-bar"
        />

        {booking ? (
          <Stepper activeStep={stepIndex} className="stepper">
            <Step>
              <StepLabel></StepLabel>
            </Step>
            <Step>
              <StepLabel></StepLabel>
            </Step>
            <Step>
              <StepLabel></StepLabel>
            </Step>
          </Stepper>
        ) : '' }
        

        <div className="app-content">
          {finished ? (
            <p>
              Rendez-vous confirmé.<br />
              <a
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  location.reload();
                }}
              >
                Cliquez ici
              </a> pour reset l'exemple.
            </p>
          ) : (
            <div>
              <ExpandTransition loading={loading} open={true}>
                {booking ? 
                  this.getStepContent(stepIndex)
                  : (
                    <div className="disabled-message">
                      <p>La prise de rendez-vous est désactivée.</p>
                    </div>
                  )
                }
                <br /><br />
              </ExpandTransition>
            </div>
          )}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/OnlineBooking.js